export function toSortSelectionValue(sort: { field: string; order: 'asc' | 'desc' }) {
  return `_${sort.field}_${sort.order}`;
}
